webpackJsonp([1],{

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parallax__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parallax___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__parallax__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__section__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__section___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__section__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__parallax___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__section___default.a; });
/**
 * Export VcParallax, VcParallaxSection and add to Vue
 * @module
 */




__WEBPACK_IMPORTED_MODULE_0__parallax___default.a.install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_0__parallax___default.a.name, __WEBPACK_IMPORTED_MODULE_0__parallax___default.a);
};

__WEBPACK_IMPORTED_MODULE_1__section___default.a.install = function install(Vue) {
  Vue.component(__WEBPACK_IMPORTED_MODULE_1__section___default.a.name, __WEBPACK_IMPORTED_MODULE_1__section___default.a);
};



/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_vc_parallax_index_js__ = __webpack_require__(1);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VcParallax", function() { return __WEBPACK_IMPORTED_MODULE_0__components_vc_parallax_index_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VcParallaxSection", function() { return __WEBPACK_IMPORTED_MODULE_0__components_vc_parallax_index_js__["b"]; });




/***/ }),

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VcParallax',
  components: {
    VcStyle: __WEBPACK_IMPORTED_MODULE_0__style___default.a
  },
  data: function data() {
    return {
      nav: [],
      currentSection: null,
      cssClass: 'vc-parallax',
      dataIndex: 'data-index'
    };
  },

  watch: {
    /**
     * Current section watcher
     */
    currentSection: function currentSection() {
      var sectionId = this.currentSection;
      var element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth'
        });
        this.$emit('section-change', {
          sectionId: sectionId,
          sectionIndex: parseInt(element.getAttribute(this.dataIndex), 10)
        });
      }
    }
  },
  props: {
    /**
     * Navigation component color
     */
    navColor: {
      type: String,
      required: false,
      default: '#ccc'
    },
    /**
     * Navigation accented color
     */
    navAccentColor: {
      type: String,
      required: false,
      default: '#282828'
    },
    /**
     * Navigation position
     */
    navPosition: {
      type: String,
      required: false,
      default: 'right'
    },
    /**
     * Navigation type ('buttons'|'scroll')
     */
    navType: {
      type: String,
      required: false,
      default: 'buttons'
    }
  },
  created: function created() {
    this.onCreated();
  },
  mounted: function mounted() {
    this.onMounted();
  },
  beforeDestroy: function beforeDestroy() {
    this.emitEvent('before-destroy');
  },

  methods: {
    /**
     * Handler for the created callback of the component
     * @method onCreated
     * @return {void}
     */
    onCreated: function onCreated() {
      var _this = this;

      this.$root.$on('navigate-to-section', function (index) {
        _this.currentSection = _this.nav[index];
      });
    },

    /**
     * Return the component data emitted by component events
     * @method label
     * @params {string} id [id=null]
     * @return {string}
     */
    label: function label() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (id) {
        return 'label-' + id;
      }
    },

    /**
     * Return the component data emitted by component events
     * @method getComponentData
     * @return {object}
     */
    getComponentData: function getComponentData() {
      return {
        nav: this.nav,
        props: this.$props,
        sectionId: this.currentSection
      };
    },

    /**
     * Trigger one of the custom events of the component
     * @method emitEvent
     * @param {string} event [event="mounted"]
     * @return {void}
     */
    emitEvent: function emitEvent() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'mounted';

      this.$emit(event, this.getComponentData());
    },

    /**
     * Handler for the mounted callback of the component
     * @method onMounted
     * @return {void}
     */
    onMounted: function onMounted() {
      var _this2 = this;

      var cssClass = this.cssClass + '-section';
      var sections = this.$el.querySelectorAll('section');
      var nav = [];
      if (!sections.length) {
        return console.error('The <vc-parallax /> component should contain at least one <vc-parallax-section /> element.');
      }
      sections.forEach(function (section, index) {
        var id = section.id;
        section.classList.add(index % 2 === 0 ? cssClass + '-parallax' : cssClass + '-static');
        section.setAttribute(_this2.dataIndex, index);
        nav.push(id);
        if (index === 0) {
          _this2.currentSection = id;
        }
      });
      this.nav = nav;
      this.emitEvent();
    }
  }
});

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid_v4__);
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VcParallaxSection',
  components: {
    VcStyle: __WEBPACK_IMPORTED_MODULE_0__style___default.a
  },
  data: function data() {
    return {
      id: __WEBPACK_IMPORTED_MODULE_1_uuid_v4___default()(),
      cssClass: this.$parent.cssClass + '-section'
    };
  },

  props: {
    /**
     * URL of the section background
     */
    backdrop: {
      type: String,
      required: false
    },
    /**
     * Background color of a static section
     */
    bgColor: {
      type: String,
      required: false,
      default: '#282828'
    },
    /**
     * Default color of the section
     */
    color: {
      type: String,
      required: false,
      default: '#fff'
    }
  },
  mounted: function mounted() {
    this.onMounted();
  },

  methods: {
    /**
     * Handler for the mounted callback of the component
     * @method onMounted
     * @return {void}
     */
    onMounted: function onMounted() {
      if (!this.$parent.$el.classList.contains('vc-parallax')) {
        console.error('The <vc-parallax-section /> element should be nested inside of a <vc-parallax /> component.');
      }
    }
  }
});

/***/ }),

/***/ 17:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VcStyle',
  render: function render(createElement) {
    return createElement('style', this.$slots.default);
  }
});

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(48),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(45),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 45:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    class: [_vm.cssClass],
    attrs: {
      "role": "complementary",
      "id": (_vm.cssClass + "-" + _vm.id)
    }
  }, [_vm._t("default"), _vm._v(" "), _c('div', {
    class: [(_vm.cssClass + "-backdrop")],
    style: ({
      backgroundImage: ("url(" + _vm.backdrop + ")")
    }),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('vc-style', [_vm._v("\n  #" + _vm._s(_vm.cssClass) + "-" + _vm._s(_vm.id) + " {\n    color: " + _vm._s(_vm.color) + ";\n    background-color: " + _vm._s(_vm.bgColor) + ";\n  }\n  ")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 48:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    class: [_vm.cssClass],
    attrs: {
      "role": "main"
    }
  }, [(_vm.navType === 'buttons') ? _c('nav', {
    class: [(_vm.cssClass + "-nav")],
    attrs: {
      "role": "navigation",
      "aria-label": "parallax navigation",
      "data-nav-position": _vm.navPosition
    }
  }, [_c('form', [_c('ul', _vm._l((_vm.nav), function(item, index) {
    return (_vm.nav.length) ? _c('li', {
      key: index
    }, [_c('label', {
      attrs: {
        "for": _vm.label(item),
        "title": index + 1
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.currentSection),
        expression: "currentSection"
      }],
      attrs: {
        "id": _vm.label(item),
        "aria-hidden": "true",
        "type": "radio",
        "name": _vm.cssClass
      },
      domProps: {
        "value": item,
        "checked": _vm._q(_vm.currentSection, item)
      },
      on: {
        "change": function($event) {
          _vm.currentSection = item
        }
      }
    }), _c('span')])]) : _vm._e()
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    class: [(_vm.cssClass + "-sections")]
  }, [_vm._t("default"), _vm._v(" "), _c('vc-style', [_vm._v("\n      html,\n      body,\n      ::-webkit-scrollbar\n      {\n        background: " + _vm._s(_vm.navColor) + ";\n      }\n\n      ::-webkit-scrollbar-corner,\n      ::-webkit-scrollbar-thumb\n      {\n        background: " + _vm._s(_vm.navAccentColor) + ";\n      }\n\n      .vc-parallax-nav,\n      .vc-parallax-nav span\n      {\n        border: solid 2px " + _vm._s(_vm.navColor) + ";\n      }\n\n      .vc-parallax-nav input:checked + span\n      {\n        background: " + _vm._s(_vm.navColor) + ";\n      }\n    ")])], 2)])
},staticRenderFns: []}

/***/ })

},[13]);


// WEBPACK FOOTER //
// docs/js/vc-parallax.5fef45b42e96bd60891a.js